import { type ImgHTMLAttributes, useCallback, useState } from 'react'
import styled from 'styled-components'

export interface BaseImgProps extends ImgHTMLAttributes<HTMLImageElement> {
  src: string
  alt: string
  width: number | string
  height: number | string
  onError?: () => void
}

const StyledImg = styled.img`
  border: none;
  display: block;
  max-width: 100%;
`

const Placeholder = styled.svg`
  vertical-align: middle;
  margin-inline: auto;
`

export function BaseImg({ onError, ...props }: BaseImgProps) {
  const [currentSrc, setCurrentSrc] = useState(props.src)
  const [errored, setErrored] = useState(false)

  if (props.src !== currentSrc) {
    setCurrentSrc(props.src)
    setErrored(false)
  }

  const handleError = useCallback(() => {
    setErrored(true)
    onError?.()
  }, [onError])

  if (errored) {
    return (
      <Placeholder
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        width={props.width}
        height={props.height}
      >
        <rect width={'24'} height={'24'} rx={'2'} fill={'#e0e0e0'} />
        <path d={'M5 19l4.5-6 3 4 2-2.5L19 19H5Z'} fill={'#bdbdbd'} />
        <circle cx={'8.5'} cy={'9.5'} r={'1.5'} fill={'#bdbdbd'} />
      </Placeholder>
    )
  }

  return <StyledImg loading={'lazy'} decoding={'async'} onError={handleError} {...props} />
}
